import _ from "lodash";
import { DatePicker, LinearProgress } from "material-ui";
import Paper from "material-ui/Paper";
import IconAdd from "material-ui/svg-icons/content/add-circle";
import IconLense from "material-ui/svg-icons/image/lens";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as customappsActions from "../actions/customapps";
import ActionButton from "../components/common/ActionButton";
import ActionDialogue from "../components/common/ActionDialogue";
import ImageWithDialogPreview from "../components/common/ImageWithDialogPreview";
import NormalBigButton from "../components/common/NormalBigButton";
import NormalTextField from "../components/common/NormalTextField";
import SectionTitle from "../components/common/SectionTitle";
import Subtitle from "../components/common/Subtitle";
import Title from "../components/common/Title";
import colors from "../styles/colors";
import layout from "../styles/layout";
import AppFrame from "./Appframe/AppFrame";
import {
  calculateDateDifInDays,
  formatSecondsForDate,
} from "./utils/timeUtils";
import events from "../services/events";

const style = {
  dateField: {
    maxWidth: 150,
    fontSize: 16,
    fontWeight: 600,
    height: 35,
  },
  buttonsContaier: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  progressContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  progressBarStyle: {
    height: "10px",
    color: colors.darkGrey,
    borderRadius: "5px",
    marginBottom: "5px",
  },
  goalDatesContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  goalDateText: {
    color: colors.tundora,
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: "700",
  },
  submittedByText: {
    fontSize: 10,
    fontWeight: "500",
    fontFamily: "Poppins",
    color: colors.mineShaft,
    opacity: 0.6,
  },
  progressNote: {
    fontSize: 12,
    fontWeight: "500",
    fontFamily: "Poppins",
    color: colors.black,
    opacity: 0.5,
  },
  videoContainer: {
    justifyContent: "center",
    marginRight: 8,
    marginBottom: 8,
    height: 200,
    width: 300,
  },
  progressImage: {
    height: 200,
    width: 300,
    borderRadius: 4,
    marginRight: 8,
    marginBottom: 8,
  },
  videoPlayer: {
    flex: 1,
    height: 200,
    width: 300,
  },
};

class PatientGoal extends Component {
  constructor(props) {
    super(props);

    let appId = props.match.params.appId;
    let userId = props.match.params.userId;

    let userInfo = {};
    if (this.props.appusers.appUsers[appId]) {
      userInfo = _.find(this.props.appusers.appUsers[appId], [
        "userId",
        parseInt(userId, 10),
      ]).userInfo;
    }
    let appUserName = userInfo.lastName
      ? `${userInfo.firstName} ${userInfo.lastName}`
      : userInfo.email;

    this.state = {
      appId,
      userId,
      width: 0,
      height: 0,

      isPatient: this.props.user.isPatient,
      appUserName,
      goalEditMode: false,
      goalId: null,
      goal: "",
      startDate: new Date(),
      endDate: new Date(),
      percentageCompleted: 0.0,
      progressList: [],
      selectedProgressItem: null,
      attachments: [],
      customApp: {},
    };
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillMount() {
    this.props.fetchCustomApp(this.state.appId, this.state.userId);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.userId &&
      this.state.appId &&
      _.isEmpty(this.state.customApp) &&
      !_.isEmpty(nextProps.customapps.customApps[this.state.appId])
    ) {
      const customApps = nextProps.customapps.customApps[this.state.appId];
      this.setState({
        customApp: customApps[this.state.userId],
      });
      this.props.getCustomAppGoal(customApps[this.state.userId].customAppId);
    }

    if (
      !_.isEmpty(this.state.customApp) &&
      nextProps.goals &&
      nextProps.goals[this.state.customApp.customAppId]
    ) {
      if (_.isEmpty(nextProps.goals[this.state.customApp.customAppId])) {
        this.setState({ goalEditMode: true });
      } else {
        const thisGoal = nextProps.goals[this.state.customApp.customAppId];
        this.setState({
          goalId: thisGoal.goalId,
          goal: thisGoal.goal,
          startDate: this.getDateObject(thisGoal.startDate),
          endDate: this.getDateObject(thisGoal.endDate),
          percentageCompleted:
            thisGoal.percentageCompleted !== undefined
              ? thisGoal.percentageCompleted
              : 0.0,
          progressList: thisGoal.progressList,
          goalEditMode: false,
        });
      }
    }

    if (!_.isEmpty(nextProps.user) && nextProps.user.userId) {
      this.setState({ isPatient: nextProps.user.isPatient });
    }
  }

  handleStartDateChanged = (event, date) => {
    this.setState({ startDate: date });
  };

  handleEndDateChanged = (event, date) => {
    this.setState({ endDate: date });
  };

  toggleEditGoalMode() {
    this.setState({ goalEditMode: !this.state.goalEditMode });
  }

  getDateObject(date) {
    let dateObj = new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0);
    return dateObj;
  }

  getProgressPercentageCompleted() {
    let totalDays = calculateDateDifInDays(
      this.state.endDate,
      this.state.startDate
    );

    let remainingDays = calculateDateDifInDays(
      new Date(),
      this.state.startDate
    );

    if (totalDays < 1 || remainingDays < 1) {
      return 0;
    } else {
      const percentage = (remainingDays / totalDays) * 100;
      return percentage.toFixed(0);
    }
  }

  saveGoal() {
    if (this.state.goalId) {
      return this.props
        .updateCustomAppGoal(
          this.state.customApp.customAppId,
          this.state.goalId,
          this.state.goal,
          moment(this.state.startDate).format("MM-DD-YYYY"),
          moment(this.state.endDate).format("MM-DD-YYYY"),
          this.state.percentageCompleted
        )
        .then(() => {
          console.debug("Goal updated successfully...");
        });
    } else {
      return this.props
        .addCustomAppGoal(
          this.state.customApp.customAppId,
          this.state.goal,
          moment(this.state.startDate).format("MM-DD-YYYY"),
          moment(this.state.endDate).format("MM-DD-YYYY")
        )
        .then(() => {
          console.debug("Goal created successfully...");
        });
    }
  }

  resetGoalConfirmationDialogue() {
    return (
      <ActionDialogue
        ref="resetGoalConfDialogue"
        title="Warning"
        content="Are you sure you want to reset the goal for this patient?"
        onConfirm={() => {
          this.props
            .removeCustomAppGoal(
              this.state.customApp.customAppId,
              this.state.goalId
            )
            .then(() => {
              this.setState({
                goalId: null,
                goal: "",
                startDate: new Date(),
                endDate: new Date(),
                percentageCompleted: 0.0,
                progressList: [],
                selectedProgressItem: null,
                attachments: [],
                goalEditMode: true,
              });
            });
        }}
      />
    );
  }

  renderEditGoal() {
    return (
      <Paper style={layout.common.paperContainer}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div>
            <p
              style={
                ({ ...layout.common.label },
                {
                  color:
                    this.props.whiteLabelSettings &&
                    this.props.whiteLabelSettings.isWhiteLabel
                      ? this.props.whiteLabelSettings.primaryColor
                      : "",
                })
              }
            >
              Start Date
            </p>
            <DatePicker
              defaultDate={new Date()}
              minDate={new Date()}
              onChange={this.handleStartDateChanged}
              textFieldStyle={style.dateField}
            />
          </div>
          <div style={{ padding: "0 20px" }}>
            <p
              style={
                ({ ...layout.common.label },
                {
                  color:
                    this.props.whiteLabelSettings &&
                    this.props.whiteLabelSettings.isWhiteLabel
                      ? this.props.whiteLabelSettings.primaryColor
                      : "",
                })
              }
            >
              End Date
            </p>
            <DatePicker
              defaultDate={this.state.endDate}
              minDate={new Date()}
              onChange={this.handleEndDateChanged}
              textFieldStyle={style.dateField}
            />
          </div>
        </div>
        <NormalTextField
          floatingLabelText="Goal Description"
          fullWidth={true}
          multiLine={true}
          rows={3}
          rowsMax={5}
          value={this.state.goal}
          onChange={(event) => {
            this.setState({ goal: event.target.value });
          }}
        />
        <div style={style.buttonsContaier}>
          {this.state.goalId !== null && (
            <NormalBigButton
              label="Reset Goal"
              onClick={() => this.refs.resetGoalConfDialogue.open()}
            />
          )}
          <ActionButton
            whiteLabelSettings={this.props.whiteLabelSettings}
            label={this.state.goalId === null ? "Set Goal" : "Update Goal"}
            onClick={() => this.saveGoal()}
          />
        </div>
      </Paper>
    );
  }

  onVideoEnd(attachment) {
    events().trackUserEvent(
      "Video Watched Until End",
      this.state.customApp.appId,
      this.state.customApp.customAppId,
      null,
      this.state.goalId,
      this.props.user.userId,
      this.state.customApp.userId,
      "mobile",
      this.state.customApp.appInfo.appName,
      null,
      JSON.stringify({
        type: "Goal Video",
        attachment: attachment,
      })
    );
  }
  onVideoPlay(attachment) {
    events().trackUserEvent(
      "Video Watched",
      this.state.customApp.appId,
      this.state.customApp.customAppId,
      null,
      this.state.goalId,
      this.props.user.userId,
      this.state.customApp.userId,
      "mobile",
      this.state.customApp.appInfo.appName,
      null,
      JSON.stringify({
        type: "Goal Video",
        attachment: attachment,
      })
    );
  }

  renderGoalProgress(progressList) {
    return (
      <div>
        {progressList.map((progress, index) => {
          const imagesList = progress.attachmentList.filter((attachment) => {
            return attachment.type === "Image";
          });

          const videosList = progress.attachmentList.filter((attachment) => {
            return attachment.type === "Video";
          });

          return (
            <Paper style={layout.common.paperContainer}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <IconLense
                    style={{ height: 15, width: 15, margin: 5 }}
                    color={
                      this.props.whiteLabelSettings &&
                      this.props.whiteLabelSettings.isWhiteLabel
                        ? this.props.whiteLabelSettings.accentColor
                        : colors.orange
                    }
                  />
                  <p style={style.goalDateText}>
                    {formatSecondsForDate(progress.createdAt.seconds)}
                  </p>
                </div>
              </div>

              <div style={{ margin: 10 }}>
                <p style={style.progressNote}>{progress.description}</p>
                <p style={style.submittedByText}>
                  Submitted on{" "}
                  {formatSecondsForDate(progress.createdAt.seconds)}
                </p>

                {videosList.length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <p
                      style={
                        ({ ...layout.common.label },
                        {
                          color:
                            this.props.whiteLabelSettings &&
                            this.props.whiteLabelSettings.isWhiteLabel
                              ? this.props.whiteLabelSettings.primaryColor
                              : "",
                        })
                      }
                    >
                      Video
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                      }}
                    >
                      {videosList.map((attachment, i) => (
                        <div style={style.videoContainer}>
                          <video
                            controls="controls"
                            x-webkit-airplay="allow"
                            src={attachment.url}
                            style={style.videoPlayer}
                            controlsList="nodownload"
                            onPlay={() => this.onVideoPlay(attachment)}
                            onEnd={() => this.onVideoEnd(attachment)}
                          ></video>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {imagesList.length > 0 && (
                  <div style={{ marginHorizontal: 10 }}>
                    <p
                      style={
                        ({ ...layout.common.label },
                        {
                          color:
                            this.props.whiteLabelSettings &&
                            this.props.whiteLabelSettings.isWhiteLabel
                              ? this.props.whiteLabelSettings.primaryColor
                              : "",
                        })
                      }
                    >
                      Photos
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                      }}
                    >
                      {imagesList.map((attachment, i) => (
                        <ImageWithDialogPreview url={attachment.url} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </Paper>
          );
        })}
      </div>
    );
  }

  renderPreviewGoal() {
    return (
      <div>
        <Paper style={layout.common.paperContainer}>
          <div style={style.buttonsContaier}>
            {!this.state.isPatient && (
              <ActionButton
                label="Edit Goal"
                onClick={() => {
                  this.toggleEditGoalMode();
                }}
                whiteLabelSettings={this.props.whiteLabelSettings}
              />
            )}
          </div>
          <div>
            <p
              style={
                ({ ...layout.common.label },
                {
                  color:
                    this.props.whiteLabelSettings &&
                    this.props.whiteLabelSettings.isWhiteLabel
                      ? this.props.whiteLabelSettings.primaryColor
                      : "",
                })
              }
            >
              Goal
            </p>
            <p>{this.state.goal}</p>
          </div>
          <div style={style.goalDatesContainer}>
            <div>
              <p
                style={
                  ({ ...layout.common.label },
                  {
                    color:
                      this.props.whiteLabelSettings &&
                      this.props.whiteLabelSettings.isWhiteLabel
                        ? this.props.whiteLabelSettings.primaryColor
                        : "",
                  })
                }
              >
                {formatSecondsForDate(this.state.startDate.getTime() / 1000)}
              </p>
              <p>Start Date</p>
            </div>
            <div style={{ padding: "0 20px" }}>
              <p
                style={
                  ({ ...layout.common.label },
                  {
                    color:
                      this.props.whiteLabelSettings &&
                      this.props.whiteLabelSettings.isWhiteLabel
                        ? this.props.whiteLabelSettings.primaryColor
                        : "",
                  })
                }
              >
                {formatSecondsForDate(this.state.endDate.getTime() / 1000)}
              </p>
              <p>End Date</p>
            </div>
          </div>
          <br />
          <LinearProgress
            mode="determinate"
            max={100}
            color={"na"}
            value={this.getProgressPercentageCompleted()}
            style={style.progressBarStyle}
          />
          <div style={style.progressContainer}>
            <p>{formatSecondsForDate(new Date().getTime() / 1000)}</p>
            <p>{this.getProgressPercentageCompleted()}%</p>
          </div>
        </Paper>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <SectionTitle
            text="Goal Progress"
            whiteLabelSettings={this.props.whiteLabelSettings}
          />
          <IconAdd
            fontSize="large"
            color={
              this.props.whiteLabelSettings &&
              this.props.whiteLabelSettings.isWhiteLabel
                ? this.props.whiteLabelSettings.primaryColor
                : colors.primary
            }
            onClick={() =>
              this.props.history.push(`/add-goal-progress/${this.state.goalId}`)
            }
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <AppFrame
        auth={this.props.auth}
        header="Manage User"
        optionsType="goal"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div style={layout.common.page}>
          <Title
            goBack={() => this.props.history.goBack()}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />
          <br />
          <br />
          <div style={layout.common.mainContainer}>
            {this.state.isPatient && _.isEmpty(this.state.goal) && (
              <p>
                You do not have a goal. Please speak with your provider about
                setting your first goal.
              </p>
            )}
            {!this.state.isPatient && (
              <Subtitle text={`${this.state.appUserName}'s Goal`} />
            )}
            <br />
            {!this.state.isPatient &&
              (this.state.goalId === null || this.state.goalEditMode) &&
              this.renderEditGoal()}
            {!this.state.goalEditMode &&
              this.state.goalId !== null &&
              this.renderPreviewGoal()}
            {this.state.progressList &&
              this.renderGoalProgress(this.state.progressList)}
          </div>
        </div>

        {this.resetGoalConfirmationDialogue()}
      </AppFrame>
    );
  }
}

function mapStateToProps({
  user,
  apps,
  appusers,
  customapps,
  whiteLabelSettings,
}) {
  return {
    user,
    apps,
    appusers,
    customapps,
    isPatient: user.isPatient,
    goals: customapps.goals,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...customappsActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientGoal);



// WEBPACK FOOTER //
// ./src/layout/PatientGoal.js